<button #originRef (click)="showPopover()" [class.active]="dropdownOpen" class="button" mat-icon-button type="button">
  <iconify-icon [icon]="icNotificationsActive" width="24" height="24">
  </iconify-icon>
</button>